import { makeObservable, observable, action } from "mobx";
import { PresaleData } from "../types/Presale";
import { Presale } from "../utils/classes/presale-manager/Presale";
import { createClient, http } from "viem";
import { bsc } from "viem/chains";
import { readContract } from "viem/actions";
import { PRESALE_CONTRACT_ADDRESS, PRESALE_ID } from "../utils/constants";
import { presaleAbi } from "../utils/abis/presaleAbi";

class PresaleStore {
  presaleData: Presale | undefined;

  constructor() {
    makeObservable(this, {
      presaleData: observable,
      setPresaleData: action,
    });
  }

  setPresaleData = async () => {
    const client = createClient({
      chain: bsc,
      transport: http("https://rpc.ankr.com/bsc/08d1966efe37214196563805bf046804732757d8e34e2cd68287dd4c3198c2ef"),
    });
    const data = await readContract(client, {
      address: PRESALE_CONTRACT_ADDRESS,
      abi: presaleAbi,
      functionName: "presale",
      args: [PRESALE_ID],
    });

    const parsedData = {
      saleToken: data?.[0],
      startTime: data?.[1],
      endTime: data?.[2],
      price: data?.[3],
      tokensToSell: data?.[4],
      baseDecimals: data?.[5],
      inSale: data?.[6],
      vestingStartTime: data?.[7],
      vestingCliff: data?.[8],
      vestingPeriod: data?.[9],
      enableBuyWithEth: data?.[10],
      enableBuyWithUsdt: data?.[11],
    } as PresaleData;

    this.presaleData = new Presale(parsedData);
  };
}
const presaleStore = new PresaleStore();
presaleStore.setPresaleData();

export default presaleStore;
